<mat-card>
    <h1 class="subtitle col-md-12">{{texteService.getTexte('TITLE_DEMANDE')}}</h1>
    <mat-card-content class="col-md-12">
        <form [formGroup]="demandeForm">
            <div class="form-row d-flex align-self-center">
                <span id="demande-specialite-label" class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_SPECIALITE')}}<span
                        class="red-label">*</span></span>

                <mat-form-field class="col-md-7">
                    <mat-select formControlName="specialite" (selectionChange)="onSpecialiteChanged($event)" aria-labelledby="demande-specialite-label">
                        <mat-option class="scroll-matToolTip" *ngFor="let specialite of specialites" [value]="specialite" 
                            matTooltip="{{texteService.getTexte(specialite.codeTexte, specialite.libelle)}}">
                            {{texteService.getTexte(specialite.codeTexte, specialite.libelle)}}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="demandeForm.controls.specialite.touched && demandeForm.controls.specialite.hasError('required')">
                        {{texteService.getTexte('ERR_CHAMP_REQUIRED')}}</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center" *ngIf="pathologies.length > 0">
                <span id="demande-pathologie-label" class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_PATHOLOGIE')}}<span
                        class="red-label">*</span></span>
                <mat-form-field class="col-md-7">
                    <mat-select formControlName="pathologie" aria-labelledby="demande-pathologie-label">
                        <mat-option class="scroll-matToolTip" *ngFor="let pathologie of pathologies" [value]="pathologie"
                            matTooltip="{{texteService.getTexte(pathologie.codeTexte, pathologie.libelle)}}">
                            {{texteService.getTexte(pathologie.codeTexte, pathologie.libelle)}}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="demandeForm.controls.pathologie.touched && demandeForm.controls.pathologie.hasError('required')">
                        {{texteService.getTexte('ERR_CHAMP_REQUIRED')}}</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center" *ngIf="typesSelected.situation.code === 'FRA'">
                <span id="demande-cancer-label" class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_DEMANDE_CANCER')}}</span>
                <mat-radio-group class="col-md-7" formControlName="cancer" aria-labelledby="demande-cancer-label">
                    <mat-radio-button value="true">{{texteService.getTexte('LABEL_OUI')}}</mat-radio-button>
                    <mat-radio-button value="false">{{texteService.getTexte('LABEL_NON')}}</mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="form-row d-flex align-self-center">
                <h6>{{texteService.getTexte('LABEL_DEMANDE_SUBTITLE')}}</h6>
            </div>

            <div class="form-row d-flex align-self-center" *ngIf="typesSelected.situation.code === 'INT'">
                <div class="col-md-5 d-flex align-self-center">
                    <mat-icon (click)="tooltipPassport.show()" #tooltipPassport="matTooltip"
                        matTooltip="{{texteService.getTexte('TOOLTIP_DEMANDE_PASSPORT')}}">
                        info</mat-icon>
                    &nbsp;
                    <label for="demande-file-passport">{{texteService.getTexte('LABEL_DEMANDE_PASSPORT')}}</label>
                </div>
                <div class="col-md-7">
                    <app-upload-file-custom inputId="demande-file-passport" (fileChange)="onFileChange($event, 'FilePassport')" [internationnal]="true">
                    </app-upload-file-custom>
                    <mat-error
                        *ngIf="demandeForm.controls.FilePassport.touched && demandeForm.controls.FilePassport.hasError('required')">
                        {{texteService.getTexte('ERR_CHAMP_REQUIRED')}}</mat-error>
                    <mat-error *ngIf="demandeForm.controls.FilePassport.hasError('extensionError')">
                        {{texteService.getTexte('ERR_FILE_EXTENSION')}}
                    </mat-error>
                </div>
            </div>

            <div class="form-row d-flex align-self-center" *ngIf="typesSelected.situation.code === 'INT'">
                <div class="col-md-5 d-flex align-self-center">
                    <mat-icon (click)="tooltipUE.show()" #tooltipUE="matTooltip"
                        matTooltip="{{texteService.getTexte('TOOLTIP_DEMANDE_UE')}}">
                        info</mat-icon>
                    &nbsp;
                    <label for="demande-file-ue">{{texteService.getTexte('LABEL_DEMANDE_UE')}}<span *ngIf="typesSelected.couverture.code === 'CUE'"
                        class="red-label">*</span></label>
                </div>
                <div class="col-md-7">
                    <app-upload-file-custom inputId="demande-file-ue" (fileChange)="onFileChange($event, 'FileUE')" [internationnal]="true">
                    </app-upload-file-custom>
                    <mat-error
                        *ngIf="demandeForm.controls.FileUE.touched && demandeForm.controls.FileUE.hasError('required')">
                        {{texteService.getTexte('ERR_CHAMP_REQUIRED')}}</mat-error>
                    <mat-error *ngIf="demandeForm.controls.FileUE.hasError('extensionError')">
                        {{texteService.getTexte('ERR_FILE_EXTENSION')}}
                    </mat-error>
                </div>
            </div>

            <div class="form-row d-flex align-self-center"
                *ngIf="typesSelected.situation.code === 'INT' && typesSelected.couverture.code === 'CAP'">
                <div class="col-md-5 d-flex align-self-center">
                    <mat-icon (click)="tooltipJustif.show()" #tooltipJustif="matTooltip"
                        matTooltip="{{texteService.getTexte('TOOLTIP_DEMANDE_JUSTIF')}}">
                        info</mat-icon>
                    &nbsp;
                    <label for="demande-file-justif">{{texteService.getTexte('LABEL_DEMANDE_JUSTIF')}}</label>
                </div>
                <div class="col-md-7">
                    <app-upload-file-custom inputId="demande-file-justif" (fileChange)="onFileChange($event, 'FileJustif')" [internationnal]="true">
                    </app-upload-file-custom>
                    <mat-error *ngIf="demandeForm.controls.FileJustif.hasError('extensionError')">
                        {{texteService.getTexte('ERR_FILE_EXTENSION')}}
                    </mat-error>
                </div>
            </div>

            <div class="form-row d-flex align-self-center" *ngIf="typesSelected.situation.code === 'INT'">
                <div class="col-md-5 d-flex align-self-center">
                    <mat-icon (click)="tooltipCRM.show()" #tooltipCRM="matTooltip"
                        matTooltip="{{texteService.getTexte('TOOLTIP_DEMANDE_CRM')}}">
                        info</mat-icon>
                    &nbsp;
                    <label for="demande-file-crm">{{texteService.getTexte('LABEL_DEMANDE_CRM')}}</label>
                </div>
                <div class="col-md-7">
                    <app-upload-file-custom inputId="demande-file-crm" (fileChange)="onFileChange($event, 'FileCRM')" [internationnal]="true">
                    </app-upload-file-custom>
                    <mat-error *ngIf="demandeForm.controls.FileCRM.hasError('extensionError')">
                        {{texteService.getTexte('ERR_FILE_EXTENSION')}}
                    </mat-error>
                </div>
            </div>

            <div class="form-row d-flex align-self-center" *ngIf="typesSelected.situation.code === 'INT'">
                <div class="col-md-5 d-flex align-self-center">
                    <mat-icon (click)="tooltipCRO.show()" #tooltipCRO="matTooltip"
                        matTooltip="{{texteService.getTexte('TOOLTIP_DEMANDE_CRO')}}">
                        info</mat-icon>
                    &nbsp;
                    <label for="demande-file-cro">{{texteService.getTexte('LABEL_DEMANDE_CRO')}}</label>
                </div>
                <div class="col-md-7">
                    <app-upload-file-custom inputId="demande-file-cro" (fileChange)="onFileChange($event, 'FileCRO')" [internationnal]="true">
                    </app-upload-file-custom>
                    <mat-error *ngIf="demandeForm.controls.FileCRO.hasError('extensionError')">
                        {{texteService.getTexte('ERR_FILE_EXTENSION')}}
                    </mat-error>
                </div>
            </div>

            <div class="form-row d-flex align-self-center" *ngIf="typesSelected.situation.code === 'INT'">
                <div class="col-md-5 d-flex align-self-center">
                    <mat-icon (click)="tooltipCRHO.show()" #tooltipCRHO="matTooltip"
                        matTooltip="{{texteService.getTexte('TOOLTIP_DEMANDE_CRHO')}}">
                        info</mat-icon>
                    &nbsp;
                    <label for="demande-file-crho">{{texteService.getTexte('LABEL_DEMANDE_CRHO')}}</label>
                </div>
                <div class="col-md-7">
                    <app-upload-file-custom inputId="demande-file-crho" (fileChange)="onFileChange($event, 'FileCRHO')" [internationnal]="true">
                    </app-upload-file-custom>
                    <mat-error *ngIf="demandeForm.controls.FileCRHO.hasError('extensionError')">
                        {{texteService.getTexte('ERR_FILE_EXTENSION')}}
                    </mat-error>
                </div>
            </div>

            <div class="form-row d-flex align-self-center" *ngIf="typesSelected.situation.code !== 'INT'">
                <div class="col-md-5 d-flex align-self-center">
                    <mat-icon (click)="tooltipMedecin.show()" #tooltipMedecin="matTooltip"
                        matTooltip="{{texteService.getTexte('TOOLTIP_DEMANDE_MEDECIN')}}">
                        info</mat-icon>
                    &nbsp;
                    <label for="demande-file-medecin">{{texteService.getTexte('LABEL_DEMANDE_MEDECIN')}}</label>
                </div>
                <div class="col-md-7">
                    <app-upload-file-custom inputId="demande-file-medecin" (fileChange)="onFileChange($event, 'FileMedecin')">
                    </app-upload-file-custom>
                    <mat-error *ngIf="demandeForm.controls.FileMedecin.hasError('extensionError')">
                        {{texteService.getTexte('ERR_FILE_EXTENSION')}}</mat-error>
                </div>
            </div>

            <div class="form-row d-flex align-self-center">
                <div class="col-md-5 d-flex align-self-center">
                    <mat-icon (click)="tooltipCRHI.show()" #tooltipCRHI="matTooltip"
                        matTooltip="{{texteService.getTexte('TOOLTIP_DEMANDE_CRHI')}}">
                        info</mat-icon>
                    &nbsp;
                    <label for="demande-file-crhi">{{texteService.getTexte('LABEL_DEMANDE_CRHI')}}</label>
                </div>
                <div class="col-md-7">
                    <app-upload-file-custom inputId="demande-file-crhi" (fileChange)="onFileChange($event, 'FileCRHI')"
                        [internationnal]="typesSelected.situation.code === 'INT'">
                    </app-upload-file-custom>
                    <mat-error *ngIf="demandeForm.controls.FileCRHI.hasError('extensionError')">
                        {{texteService.getTexte('ERR_FILE_EXTENSION')}}
                    </mat-error>
                </div>
            </div>

            <div class="form-row d-flex align-self-center">
                <div class="col-md-5 d-flex align-self-center">
                    <mat-icon (click)="tooltipCRI.show()" #tooltipCRI="matTooltip"
                        matTooltip="{{texteService.getTexte('TOOLTIP_DEMANDE_CRI')}}">
                        info</mat-icon>
                    &nbsp;
                    <label for="demande-file-cri">{{texteService.getTexte('LABEL_DEMANDE_CRI')}}</label>
                </div>
                <div class="col-md-7">
                    <app-upload-file-custom inputId="demande-file-cri" (fileChange)="onFileChange($event, 'FileCRI')"
                        [internationnal]="typesSelected.situation.code === 'INT'">
                    </app-upload-file-custom>
                    <mat-error *ngIf="demandeForm.controls.FileCRI.hasError('extensionError')">
                        {{texteService.getTexte('ERR_FILE_EXTENSION')}}
                    </mat-error>
                </div>
            </div>

            <!-- <div class="form-row d-flex align-self-center" *ngIf="typesSelected.situation.code !== 'INT' && typesSelected.situation.code !== 'FRA'">
                <div class="col-md-5 d-flex align-self-center">
                    <mat-icon (click)="tooltipSanguin.show()" #tooltipSanguin="matTooltip"
                        matTooltip="{{texteService.getTexte('TOOLTIP_DEMANDE_SANGUIN')}}">
                        info</mat-icon>
                    &nbsp;
                    <label for="demande-file-sanguin">{{texteService.getTexte('LABEL_DEMANDE_SANGUIN')}}</label>
                </div>
                <div class="col-md-7">
                    <app-upload-file-custom inputId="demande-file-sanguin" (fileChange)="onFileChange($event, 'FileSanguin')">
                    </app-upload-file-custom>
                    <mat-error *ngIf="demandeForm.controls.FileSanguin.hasError('extensionError')">
                        {{texteService.getTexte('ERR_FILE_EXTENSION')}}
                    </mat-error>
                </div>
            </div> -->

            <small>{{getTotalSize() | totalFileSize}} - {{texteService.getTexte('LABEL_DEMANDE_LIMITATION')}}</small>
            <mat-error *ngIf="demandeForm.hasError('totalSizeError')">
                {{texteService.getTexte('ERR_DEMANDE_FILE_SIZE')}}
            </mat-error>

            <div class="form-row d-flex align-self-center margin-autre-info"
                *ngIf="typesSelected.situation.code === 'INT'">
                <label for="demande-information" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_DEMANDE_INFO')}}</label>
                <mat-form-field class="col-md-7">
                    <textarea id="demande-information" matInput formControlName="information" maxlength="200" rows="5"></textarea>
                </mat-form-field>
            </div>
        </form>
    </mat-card-content>
</mat-card>
